import { Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { Container } from "./styles";

import MoustacheLogo from "../../assets/icons/moustache";

const ErrorFallbackPage = () =>
  // {error, resetErrorBoundary}
  {
    const { t } = useTranslation();
    const tRP = "pages.error_fallback";

    const refreshPage = () => {
      window.location.reload();
    };
    return (
      <Container
        onClick={refreshPage}
        title={"Click to reload the page"}
      >
        <MoustacheLogo
          width={120}
          height={30}
        />
        <Typography sx={{ fontSize: "2rem" }}>{`${t(`${tRP}.message`)}`}</Typography>
      </Container>
    );
  };

export default ErrorFallbackPage;
